import { InputField, PasswordField } from "components";
import { fieldLimits } from "config";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import styles from "../Login.module.css";

const LoginFormBody = () => {
	const { t } = useTranslation("accountsPage");

	return (
		<div className={styles.body}>
			<InputField
				autoComplete="email"
				label={t("login.emailLabel")}
				maxLength={fieldLimits.email}
				name="email"
				placeholder={t("login.emailPlaceholder")}
				type="email"
			/>
			<PasswordField
				autoComplete="current-password"
				label={t("login.passwordLabel")}
				maxLength={fieldLimits.password}
				name="password"
				placeholder={t("login.passwordPlaceholder")}
			/>
			<Link className={styles.forgotPassword} to={Paths.forgotPassword}>
				{t("login.forgotPassword")}
			</Link>
		</div>
	);
};

export default LoginFormBody;
